export default __webpack_public_path__ + "static/polygons-8af4a8200ea27f412d3e94fc58179aae.svg";